import {notNullAndNotUndefinded} from "../../helper/utils";

export const tieneAccesoAMenu = (menus, idMenu) => {
    let tieneAccesoAlMenu = false;
    let menuEncontrado = menus?.filter((menu) => menu["IdMenu"] === idMenu);
    if (notNullAndNotUndefinded(menuEncontrado) && menuEncontrado.length > 0) {
        tieneAccesoAlMenu = true;
    }
    return tieneAccesoAlMenu;
};